import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Clipboard } from '@angular/cdk/clipboard';
import { TuiButton, TuiDropdown, TuiHint, TuiTextfield } from '@taiga-ui/core';
import { TuiItemsWithMore } from '@taiga-ui/kit';
import { TuiInputColorModule, TuiInputModule, TuiTextfieldControllerModule, TuiSelectModule } from '@taiga-ui/legacy';

@Component({
    selector: 'ffx-code-block',
    standalone: true,
    imports: [
        CommonModule,
        TuiHint,
        TuiInputColorModule,
        TuiInputModule,
        TuiTextfield,
        TuiTextfieldControllerModule,
        TuiButton,
        TuiDropdown,
        TuiItemsWithMore,
        TuiSelectModule
    ],
    templateUrl: './code-block.component.html',
    styleUrl: './code-block.component.scss'
})
export class CodeBlockComponent {
    @Input() code = '';
    private clipboard = inject(Clipboard);

    copied = false;
    copyHintText = 'Copy code to clipboard';

    copyCode(): void {
        this.clipboard.copy(this.code);
        this.copyHintText = 'Code copied!';
        setTimeout(() => {
            this.copyHintText = 'Copy code to clipboard';
        }, 2000);
    }
}
